module.exports = "https://static.wanderu.com/ui-react/_next/static/media/gb.a3e6d90f.svg";